import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import styles from './process-bar.module.css'

const propTypes = {
    lowThreshold: PropTypes.number,
    max: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
}

const defaultProps = {
    lowThreshold: 0
}

export function ProcessBar({ className, lowThreshold, max, value }) {
    const currentBarClassNames = cx(
        styles['bar'],
        {
            [styles['bar-value-low']]: value < lowThreshold
        },
        className
    )

    return <progress className={currentBarClassNames} max={max} value={value} />
}

ProcessBar.propTypes = propTypes
ProcessBar.defaultProps = defaultProps
